"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listingAdditionalMandatoryFieldsSchema = exports.listingExtendedSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
var listing_schema_1 = require("./listing-schema");
exports.listingExtendedSchema = __assign(__assign({}, listing_schema_1.listingSchema), { properties: __assign(__assign({}, listing_schema_1.listingSchema.properties), { appraisalDate: __assign(__assign({}, listing_schema_1.listingSchema.properties.appraisalDate), { formatMinimum: {
                const: '1996-01-01',
                customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'appraisalDate'),
            }, strictlyPastDate: true }), revisedPriceAmount: {
            type: ['number', 'null'],
            allOf: [
                {
                    maximum: 9999999999999,
                    minimum: -9999999999999,
                    decimal: [15, 2],
                    errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
                },
                {
                    not: {
                        const: { $data: '1/priceAmount' },
                    },
                    errorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_0),
                },
            ],
        } }), allOf: [
        {
            if: {
                properties: {
                    comparativeMarketAnalysisDate: {
                        enum: ['', 'null'],
                    },
                },
            },
            else: {
                properties: {
                    comparativeMarketAnalysisDate: {
                        type: 'string',
                        format: 'date',
                        errorMessage: 'Should follow date format YYYY-MM-DD',
                        strictlyPastDate: true,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    date: {
                        enum: ['', 'null'],
                    },
                },
            },
            else: {
                properties: {
                    date: {
                        type: 'string',
                        format: 'date',
                        errorMessage: 'Should follow date format YYYY-MM-DD or null',
                        formatMinimum: {
                            const: '1996-01-01',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'date'),
                        },
                        strictlyPastDate: true,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    expiryDate: {
                        enum: ['', 'null'],
                    },
                },
            },
            else: {
                properties: {
                    expiryDate: {
                        type: ['string', 'null'],
                        format: 'date',
                        errorMessage: 'Should follow date format YYYY-MM-DD or null',
                        formatExclusiveMinimum: {
                            const: '1996-01-01',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_DATE_BEFORE_1996, 'expiryDate'),
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['periodID', 'date', 'expiryDate'],
                properties: {
                    periodID: {
                        const: constants_2.ListingPeriod.FirstListing,
                    },
                },
            },
            then: {
                properties: {
                    expiryDate: {
                        isAtLeast90Days: {
                            $data: '1/date',
                        },
                    },
                },
            },
        },
        {
            if: {
                required: ['periodID', 'date', 'expiryDate'],
                properties: {
                    periodID: {
                        const: constants_2.ListingPeriod.SecondListing,
                    },
                },
            },
            then: {
                properties: {
                    expiryDate: {
                        formatExclusiveMinimum: {
                            $data: '1/date',
                            customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_LISTING_3, 'expiryDate'),
                        },
                    },
                },
            },
        },
    ] });
exports.listingAdditionalMandatoryFieldsSchema = __assign(__assign({}, exports.listingExtendedSchema), { required: ['appraisalDate', 'appraisalValue', 'date', 'expiryDate', 'priceAmount', 'periodID'] });
